<template>
  <section id="disDetail" class="pt-2">
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-row class="ma-0 px-2">
      <v-spacer></v-spacer>
      <v-btn
        tile
        outlined
        v-if="
          user.role?.includes('RRS')
        "
        class="error white--text"
        @click="dialog = true"
        >删除</v-btn
      >
      <v-btn
        tile
        outlined
        v-if="
          user.role?.includes('Sales') ||
          user.role?.includes('Sell-in Sales') ||
          user.role?.includes('Dealer') ||
          user.role?.includes('RRS') || user.role?.includes('External Sales')
        "
        class="success white--text ml-2"
        @click="onSaveDis"
        >保存</v-btn
      >
    </v-row>
    <div id="detailForm">
      <v-form
        class="px-4"
        ref="form"
        v-model="valid"
        lazy-validation
        :readonly="
          !(
            user.role?.includes('Sales') ||
            user.role?.includes('Sell-in Sales') ||
            user.role?.includes('Dealer') ||
            user.role?.includes('RRS') || user.role?.includes('External Sales')
          )
        "
      >
        <p class="subtitle-1 font-weight-bold">经销商合作进展</p>
        <v-autocomplete
          outlined
          dense
          label="合作状态"
          :rules="[(v) => !!v || '这是必填项']"
          item-value="id"
          item-text="name"
          :clearable="user.role?.includes('Sales')"
          :items="hzzt"
          required
          v-model="dealer.developmentStateId"
          @change="onChange"
        ></v-autocomplete>
        <div style="padding: 0px 0px 25px 0px">
          <router-link to="" @click.native="goAddStore" v-if="isPc"
            >新增门店</router-link
          >
          <router-link :to="`/store/detail/0`" v-if="!isPc"
            >新增门店</router-link
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <router-link
            v-if="
              user.role?.includes('Sales') ||
              user.role?.includes('Sell-in Sales') ||
              user.role?.includes('Dealer') || user.role?.includes('External Sales')
            "
            :to="`/visiting?dealerId=${dealerId}&dealerName=${dealer.name}`"
            >新增拜访记录</router-link
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <router-link
            v-if="
              !user.role?.includes('Sales') &&
              !user.role?.includes('Sell-in Sales') &&
              !user.role?.includes('Dealer') && !user.role?.includes('External Sales')
            "
            :to="`/visiting`"
            >拜访记录</router-link
          >
        </div>

        <!-- <div v-if="dealerId">
            <router-link :to="`/visiting/listByDealer?dealer=${dealerId}`"
              >拜访记录</router-link
            >
        </div> -->

        <p class="subtitle-1 font-weight-bold">经销商基础信息</p>
        <v-text-field
          required
          :clearable="isClearable"
          outlined
          dense
          :rules="[(v) => !!v || '这是必填项']"
          label="经销商名称"
          v-model="dealer.name"
        ></v-text-field>
        <v-text-field
          required
          :clearable="isClearable"
          outlined
          dense
          :rules="[(v) => !!v || '这是必填项']"
          label="负责人"
          v-model="dealer.responsiblePerson"
        ></v-text-field>
        <v-text-field
          :rules="[
            (v) => !!v || '这是必填项',
            (v) =>
              testphone(v) || '请输入正确的11位手机号码',
          ]"
          outlined
          :clearable="isClearable"
          required
          dense
          label="负责人联系电话"
          v-model="dealer.tel"
        ></v-text-field>
        <v-autocomplete
          outlined
          :clearable="isClearable"
          dense
          label="省/直辖市 "
          :items="provinceList"
          item-value="code"
          :rules="[(v) => !!v || '这是必填项']"
          item-text="name"
          v-model="dealer.provinceCode"
          @change="setProvince($event)"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          :clearable="isClearable"
          dense
          label="市"
          :items="cityList"
          :rules="[(v) => !!v || '这是必填项']"
          item-value="code"
          item-text="name"
          v-model="dealer.cityCode"
          @change="setCity($event)"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          :clearable="isClearable"
          dense
          label="区"
          v-model="dealer.districtCode"
          :rules="[(v) => !!v || '这是必填项']"
          :items="districtList"
          item-value="code"
          item-text="name"
          @change="setDistrict($event)"
        ></v-autocomplete>
        <v-textarea
          outlined
          required
          :clearable="isClearable"
          dense
          label="详细地址"
          :rules="[(v) => !!v || '这是必填项']"
          height="60"
          v-model="dealer.address"
        ></v-textarea>
        <v-autocomplete
          outlined
          required
          dense
          label="所属一级经销商"
          v-model="dealer.parentDealerId"
          :items="dealers"
          item-value="id"
          item-text="name"
        ></v-autocomplete>
        <v-tooltip bottom v-if="isSapCodeRequired">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              required
              :clearable="isClearable"
              outlined
              dense
              :rules="[(v) => !!v || '这是必填项']"
              label="SAP客户编号"
              v-model="dealer.sapCustomerCode"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <span>新建一级时必填，为WorkON审批后在SAP里为此客户创建的Customer ID，如114000067；如果还在创建中，也请备注：客户编号创建中</span>
        </v-tooltip>
        
        <v-menu
          v-model="pickDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dealer.actualCooperationDate"
              label="合作时间"
              :clearable="isClearable"
              outlined
              dense
              readonly
              v-bind="attrs"
              :rules="[(v) => !!v || '这是必填项']"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dealer.actualCooperationDate"
            type="month"
            locale="zh"
            @input="pickDate = false"
          ></v-date-picker>
        </v-menu>
        <v-text-field
          :required="isRequired"
          :clearable="isClearable"
          outlined
          dense
          :rules="isRequired ? requiredField.juridicalPerson : []"
          label="法人"
          v-model="dealer.legalPerson"
        ></v-text-field>
        <v-text-field
          v-if="!this.isJieQia"
          outlined
          :clearable="isClearable"
          :required="isRequired"
          dense
          label="注册资金(万元)"
          :rules="isRequired ? requiredField.registeredCapital : []"
          type="number"
          v-model="dealer.registeredCapital"
        ></v-text-field>
        <v-text-field
          :required="isRequired"
          :clearable="isClearable"
          outlined
          dense
          :rules="isRequired ? requiredField.products : []"
          label="主营产品"
          v-model="dealer.mainProducts"
        ></v-text-field>
        <v-text-field
          v-if="!this.isJieQia"
          outlined
          :clearable="isClearable"
          :required="isRequired"
          dense
          label="年度营业额(万元)"
          :rules="isRequired ? requiredField.revenueForYear : []"
          type="number"
          v-model="dealer.annualRevenue"
        ></v-text-field>
        <v-text-field
          v-if="!this.isJieQia"
          outlined
          :clearable="isClearable"
          :required="isRequired"
          dense
          label="销售人员数量"
          :rules="isRequired ? requiredField.salesCount : []"
          type="number"
          v-model="dealer.salesCount"
        ></v-text-field>
        <v-text-field
          v-if="!this.isJieQia"
          outlined
          :readonly="true"
          :clearable="false"
          dense
          type="number"
          label="门店数量"
          v-model="dealer.storeCount"
        ></v-text-field>
        <v-radio-group
          v-if="!this.isJieQia"
          row
          class="mt-0"
          v-model="dealer.hasMargin"
          :value="false"
        >
          <v-label>经销商是否已交保证金</v-label>
          <v-spacer></v-spacer>
          <v-radio label="是" :value="true"></v-radio>
          <v-radio label="否" :value="false" class="mr-0"></v-radio>
        </v-radio-group>
        <!-- :rules="[
            () =>
              (!!dealer.storeCount && dealer.storeCount >= 0) ||
              '请输入大于0的数字',
          ]" -->
        <!-- <v-radio-group v-if="!this.isJieQia" row class="mt-0" v-model="dealer.signatured" :value="false">
          <v-label>是否签约</v-label>
          <v-spacer></v-spacer>
          <v-radio label="是" :value="true"></v-radio>
          <v-radio label="否" :value="false" class="mr-0"></v-radio>
        </v-radio-group>
        <v-radio-group v-if="!this.isJieQia" row class="mt-0" v-model="dealer.hasOfficialStore" :value="false">
          <v-label>是否有官网门店</v-label>
          <v-spacer></v-spacer>
          <v-radio label="是" :value="true"></v-radio>
          <v-radio label="否" :value="false" class="mr-0"></v-radio>
        </v-radio-group>
        <v-radio-group v-if="!this.isJieQia" row class="mt-0" v-model="dealer.hasWorkTeam" :value="false">
          <v-label>是否有施工团队</v-label>
          <v-spacer></v-spacer>
          <v-radio label="是" :value="true"></v-radio>
          <v-radio label="否" :value="false" class="mr-0"></v-radio>
        </v-radio-group> -->
        <p v-if="!this.isJieQia" class="subtitle-1 font-weight-bold">
          客户业务概况
        </p>
        <v-text-field
          v-if="!this.isJieQia"
          :required="isRequired"
          :clearable="user.role?.includes('Sales')"
          outlined
          dense
          label="全年(12个月)所有品牌壁挂炉采购潜力(台)"
          v-model="dealer.ovenSaleCapacity"
          :rules="isRequired ? requiredField.ovenSaleCapacity : []"
          type="number"
        ></v-text-field>
        <!-- v-if="
            dealer?.developmentStateId == 26 || dealer?.developmentStateId == 27
          " -->
        <v-text-field
          :required="isRequired"
          outlined
          dense
          label="博世壁挂炉钱包份额SoW/%"
          v-if="!this.isJieQia"
          v-model="dealer.sowShowValue"
          :rules="isRequired ? requiredField.sowShowValue : []"
          type="number"
        ></v-text-field>
        <!-- v-if="
            dealer?.developmentStateId == 26 || dealer?.developmentStateId == 27
          " -->
        <v-text-field
          :clearable="isClearable"
          outlined
          readonly
          dense
          label="预计当年博世壁挂炉采购贡献(台)"
          v-model="boschOvenSaleCapacityCompute"
          type="number"
          v-if="!this.isJieQia"
        ></v-text-field>
        <!-- <v-text-field v-if="!this.isJieQia" outlined required dense label="全年(12个月)所有品牌新风采购潜力(台)"
          v-model="dealer.ventilationSaleCapacity"
          :clearable="isClearable"
          type="number"></v-text-field>
        <v-text-field outlined dense label="博世新风钱包份额SoW/%" v-if="!this.isJieQia" v-model="dealer.sowShowValueXF"
          :clearable="isClearable"
          type="number"></v-text-field> -->
        <!-- v-if="
            dealer?.developmentStateId == 26 || dealer?.developmentStateId == 27
          " -->
        <!-- <v-text-field :clearable="user.role?.includes('Sales')" outlined readonly dense label="预计当年博世新风采购贡献(台)"
          v-if="!this.isJieQia" v-model="boschVentilationSaleCapacity" type="number"></v-text-field>
        <v-text-field v-if="!this.isJieQia" outlined dense label="全年(12个月)所有品牌热泵采购潜力(台)"
          v-model="dealer.hotPumpSaleCapacity"
          :clearable="isClearable"
          type="number"></v-text-field>
        <v-text-field outlined dense label="博世热泵钱包份额SoW/%" v-if="!this.isJieQia" v-model="dealer.sowShowValueRB"
          :clearable="isClearable"
          type="number"></v-text-field> -->
        <!-- v-if="
            dealer?.developmentStateId == 26 || dealer?.developmentStateId == 27
          " -->
        <!-- <v-text-field :clearable="user.role?.includes('Sales')" outlined readonly dense label="预计当年博世热泵采购贡献(台)"
          v-if="!this.isJieQia" v-model="boschHotPumpSaleCapacity" type="number"></v-text-field> -->

        <!-- v-if="
            dealer?.developmentStateId == 26 || dealer?.developmentStateId == 27
          " -->
        <!-- <v-autocomplete outlined dense v-if="!this.isJieQia" label="主销博世机型"
          item-value="id" :rules="boschProductRule" item-text="name" multiple small-chips
          v-model="dealer.majorBoschProductTypeIds"
          :clearable="isClearable" :items="zxjx"
          required @change="handleSelectChange"></v-autocomplete> -->
        <!-- <v-autocomplete required outlined dense :rules="[
          (v) => v?.length <= 3 || '最多选择三个！',
          (v) => !!v || '这是必填项',
        ]" multiple small-chips label="客户类型" item-value="id" item-text="name"
          :clearable="isClearable"
          v-model="dealer.majorSaleChannelIds" :items="xsqd"></v-autocomplete> -->

        <v-textarea
          v-if="!this.isJieQia"
          outlined
          dense
          label="跟进备注"
          height="60"
          :clearable="isClearable"
          required
          v-model="dealer.remark"
        ></v-textarea>

        <p class="subtitle-1 font-weight-bold">销售经理</p>
        <v-autocomplete
          outlined
          dense
          return-object
          label="-选择-"
          item-value="id"
          item-text="displayName"
          clearable
          :items="userList"
          v-model="dealer.salesId"
          @change="changeSales"
        >
        </v-autocomplete>
      </v-form>
    </div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">提示</span>
        </v-card-title>
        <v-card-text>
          <span>确认删除吗？</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="onDeleteDis()">
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </section>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/api";
export default {
  data: () => ({
    boschProductRule: [],
    isJieQia: false,
    loading: false,
    dialog: false,
    valid: false,
    pickDate: false,
    message: {
      show: false,
      type: "success",
      text: "",
    },
    dealerId: null,
    dealer: {
      id: "",
      name: "",
      responsiblePerson: "",
      tel: null,
      region: "",
      provinceCode: null,
      provinceName: null,
      cityCode: null,
      cityName: null,
      districtCode: null,
      districtName: null,
      address: "",
      parentDealerId: null,
      salesCount: null,
      storeCount: null,
      signatured: false,
      hasWorkTeam: false,
      hasOfficialStore: false,
      ovenSaleCapacity: null,
      boschOvenSaleCapacity: null,
      ventilationSaleCapacity: null,
      boschVentilationSaleCapacity: null,
      hotPumpSaleCapacity: null,
      boschHotPumpSaleCapacity: null,
      majorBoschProductTypeIds: null,
      majorSaleChannelIds: null,
      remark: null,
      salesId: null,
      salesName: null,
      developmentStateId: null,
      sowValue: null,
      sowShowValue: null,
      sowShowValueXF: null,
      sowShowValueRB: null,
      legalPerson: "",
      registeredCapital: null,
      mainProducts: "",
      annualRevenue: null,
      hasMargin: false,
      sapCustomerCode : ''
    },
    zxjx: [],
    xsqd: [],
    hzzt: [],
    dealers: [],
    provinceList: [],
    cityList: [],
    districtList: [],
    regionCode: "",
    isPc: true,
    rules: {
      tel: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        {
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: "请输入正确的手机号码",
          trigger: "blur",
        },
      ],
    },
    userList: [],
    requiredField: {
      juridicalPerson: [(v) => !!v || "这是必填项"],
      registeredCapital: [
        (v) => !!v || "这是必填项",
        (v) =>
          (!!v &&
            v >= 0) ||
          "请输入大于0的数字",
      ],
      products: [(v) => !!v || "这是必填项"],
      revenueForYear: [
        (v) => !!v || "这是必填项",
        (v) =>
          (!!v && v >= 0) ||
          "请输入大于0的数字",
      ],
      salesCount: [
        (v) => !!v || "这是必填项",
        (v) =>
          (!!v && v >= 0) ||
          "请输入大于0的数字",
      ],
      ovenSaleCapacity: [
        (v) => v >= 0 || "请输入大于或等于0的数字",
      ],
      sowShowValue: [
        (v) => v >= 0 || "请输入大于或等于0的数字",
      ],
    },
    userInfo: {},
    isCreate: true
  }),
  beforeRouteEnter(to, from, next) {
    let nextFunction = async (vm) => {
      vm.isCreate = to.params.id == 0;
      await vm.getCategroy();
      await vm.getRegion();
      if (to.params.id != 0) {
        await vm.getDisInfo(to.params.id);
      } else {
        await vm.getDisOption();
      }
    };
    next(nextFunction);
  },
  mounted() {
    var flagPc = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flagPc) {
      this.isPc = false;
    } else {
      this.isPc = true;
    }
    if (this.user.role?.includes('External Sales')) {
      this.getUserInfo();
    } else {
      this.getUserList("");
    }
    
  },
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return (
        this.user.role?.includes('HOD') ||
        this.user.role?.includes('RRS') ||
        this.user.role?.includes('SCN')
      );
    },
    isClearable() {
      return (
        this.user.role?.includes('Sales') ||
        this.user.role?.includes('Sell-in Sales') ||
        this.user.role?.includes('Dealer') ||
        this.user.role?.includes('RRS') || this.user.role?.includes('External Sales')
      );
    },
    isRequired() {
      return this.dealer.developmentStateId === 26;
    },
    isSapCodeRequired() {
      return this.dealer.developmentStateId === 26 && (this.dealer.parentDealerId === null || this.dealer.parentDealerId?.id === null);
    },
    sow() {
      const { ovenSaleCapacity, boschOvenSaleCapacity } = this.dealer;
      if (ovenSaleCapacity && boschOvenSaleCapacity && ovenSaleCapacity != 0) {
        return (
          Math.round((boschOvenSaleCapacity / ovenSaleCapacity) * 100) + "%"
        );
      } else {
        return 0;
      }
    },
    boschOvenSaleCapacityCompute: {
      get: function () {
        const { ovenSaleCapacity, sowShowValue } = this.dealer;
        if (ovenSaleCapacity && sowShowValue && ovenSaleCapacity != 0) {
          return Math.round((sowShowValue / 100) * ovenSaleCapacity);
        } else if (this.dealer.boschOvenSaleCapacity) {
          return this.dealer.boschOvenSaleCapacity;
        } else {
          return 0;
        }
      },
      set: function (val) {
        if (this.dealer.ovenSaleCapacity && this.dealer.ovenSaleCapacity > 0) {
          this.dealer.boschOvenSaleCapacity = Math.round(
            (val / 100) * this.dealer.ovenSaleCapacity
          );
        }
        this.dealer.sowValue = val / 100;
      },
    },

    boschVentilationSaleCapacity: {
      get: function () {
        const { ventilationSaleCapacity, sowShowValueXF } = this.dealer;
        if (
          ventilationSaleCapacity &&
          sowShowValueXF &&
          ventilationSaleCapacity != 0
        ) {
          return Math.round((sowShowValueXF / 100) * ventilationSaleCapacity);
        } else if (this.dealer.boschVentilationSaleCapacity) {
          return this.dealer.boschVentilationSaleCapacity;
        } else {
          return 0;
        }
      },
      set: function (val) {
        if (
          this.dealer.ventilationSaleCapacity &&
          this.dealer.ventilationSaleCapacity > 0
        ) {
          this.dealer.boschVentilationSaleCapacity = Math.round(
            (val / 100) * this.dealer.ventilationSaleCapacity
          );
        }
        this.dealer.sowValue = val / 100;
      },
    },

    boschHotPumpSaleCapacity: {
      get: function () {
        const { hotPumpSaleCapacity, sowShowValueRB } = this.dealer;
        if (hotPumpSaleCapacity && sowShowValueRB && hotPumpSaleCapacity != 0) {
          return Math.round((sowShowValueRB / 100) * hotPumpSaleCapacity);
        } else if (this.dealer.boschHotPumpSaleCapacity) {
          return this.dealer.boschHotPumpSaleCapacity;
        } else {
          return 0;
        }
      },
      set: function (val) {
        if (
          this.dealer.hotPumpSaleCapacity &&
          this.dealer.hotPumpSaleCapacity > 0
        ) {
          this.dealer.boschHotPumpSaleCapacity = Math.round(
            (val / 100) * this.dealer.hotPumpSaleCapacity
          );
        }
        this.dealer.sowValue = val / 100;
      },
    },
  },
  methods: {
    // 销售人员 修改，如果没有数据，后台会默认填充为当前操作人
    changeSales(event) {
      this.dealer.salesId = event.id;
      this.dealer.salesName = event.displayName;
    },
    getUserInfo() {
      api.user.getUserInfo(this.user.username).then((res) => {
        const { data } = res.data;
        if (res.status == 200 && data) {
          this.userInfo = data;
          const managerIdList = this.userInfo?.managerId?.split(',') ?? [];
          const managerNameList = this.userInfo?.managerName?.split(',') ?? [];
          
          this.userList = managerIdList.map((item, index) => {
            return {
              id: Number(item),
              displayName: managerNameList[index]
            };
          });

          const managerId = managerIdList[0];
          if (managerId && this.isCreate) {
            this.dealer.salesId = Number(managerId);
            this.dealer.salesName = managerNameList[0] ?? '';
            // {
            //   id: Number(managerId)
            // };
          }
          
        } else {
          this.userInfo = {};
        }
      });
    },
    // 获取所有用户数据
    getUserList($event) {
      api.user.getUsersWithKeyword($event).then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data) {
          this.userList = data;
        } else {
          this.userList = [];
        }
      });
    },
    handleSelectChange() {
      console.log("Selected items:", this.dealer.majorBoschProductTypeIds);
      if (this.dealer.majorBoschProductTypeIds.length < 1) {
        this.dealer.majorBoschProductTypeIds = null;
      }
    },
    goAddStore() {
      // window.location.href = "https://dev.salesclub.bosch-homecomfort.cn/rec/index.html#/StoreList";
      // window.location.href =
      //   process.env.VUE_APP_API_BASE_URL + "rec/index.html#/StoreList";
      window.location.href = process.env.VUE_APP_HOME_REC + "StoreList";
      return false;
    },
    testphone(v) {
      // const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
      const reg = /^(1\d{10})$/;
      if (!reg.test(v) && v != "") {
        return false;
      }
      return true;
    },
    onChange() {
      if (
        this.dealer.developmentStateId === 22 ||
        this.dealer.developmentStateId === 23
      ) {
        this.isJieQia = true;
      } else {
        this.isJieQia = false;
      }
      if (this.dealer.developmentStateId === 26) {
        this.boschProductRule = [
          (v) => !!v || "这是必填项",
          (v) => v?.length <= 3 || "最多选择三个！",
        ];
      } else {
        this.boschProductRule = [];
      }
    },
    setRegion($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion?.provinces);
      } else {
        this.provinceList = [];
      }

      this.provinceCode = null;
      this.cityCode = null;
      this.cityList = [];
    },
    async getRegion() {
      const res = await api.pca.getRegionForRoles();
      this.loading = false;
      const { data, status } = res.data;
      if (status == 200 && data) {
        this.regionList = data;
        if (!this.isAdmin) {
          this.setRegion(this.user.userRegionCode);
          this.regionCode = this.user.userRegionCode;
        } else if (
          Object.prototype.hasOwnProperty.call(this.$route.query, "region")
        ) {
          this.regionCode = this.$route.query.region;
          this.setRegion(this.regionCode);
        }
      }
    },
    getProvince(byRegion) {
      if (byRegion) {
        this.provinceList = api.pca.getProvince().filter((i) => {
          return (
            byRegion.filter((pro) => pro.provinceCode === i.code).length > 0
          );
        });
      } else {
        this.provinceList = api.pca.getProvince();
      }
    },
    setProvince($event) {
      const selectedProvince = this.provinceList.filter(
        (i) => i.code == $event
      )[0];
      this.dealer.provinceName = selectedProvince.name;
      this.cityList = api.pca.getCityByProvince($event);
      this.dealer.cityCode = null;
      this.dealer.cityName = null;
      this.dealer.districtCode = null;
      this.dealer.districtName = null;
    },
    setCity($event) {
      const selectedCity = this.cityList.filter((i) => i.code == $event)[0];
      this.dealer.cityName = selectedCity.name;
      this.districtList = this.cityList.filter(
        (i) => i.code == $event
      )[0]?.children;
      this.dealer.districtCode = null;
      this.dealer.districtName = null;
    },
    setDistrict($event) {
      const selectedDistrict = this.districtList.filter(
        (i) => i.code == $event
      )[0];
      this.dealer.districtName = selectedDistrict.name;
    },
    async getCategroy() {
      api.common.getAllCategory().then((res) => {
        const { data, status } = res.data;
        if (data && status == 200) {
          this.zxjx = data.list.filter((i) => i.categoryType == "zxjx");
          // this.xsqd = data.list.filter((i) => i.categoryType == "xsqd");
          this.xsqd = data.list
            .filter((i) => i.categoryType == "xsqd")
            .sort(function (a, b) {
              return a.sort > b.sort ? 1 : -1;
            });
          this.hzzt = data.list
            .filter((i) => i.categoryType == "hzzt")
            .sort(function (a, b) {
              return a.sort > b.sort ? 1 : -1;
            });
        }
      });
    },
    async getDisInfo(id) {
      this.dealerId = id;
      this.loading = true;
      api.dealer
        .getDealerWithId({ id })
        .then((res) => {
          if (res.data.data) {
            this.dealer = {
              ...res.data.data,
              actualCooperationDate: res.data.data?.actualCooperationDate?.slice(0, 7),
              sowShowValue: res.data.data?.sowValue * 100,
              sowShowValueXF: res.data.data?.sowValueXF * 100,
              sowShowValueRB: res.data.data?.sowValueRB * 100,
              majorBoschProductTypeIds: res.data.data?.majorBoschProductTypeIds
                ?.split(",")
                ?.map((i) => Number(i)),
              majorSaleChannelIds: res.data.data?.majorSaleChannelIds
                ?.split(",")
                ?.map((i) => Number(i)),
            };
            if (this.isAdmin || this.user.role?.includes('RM')) {
              this.setRegion(this.dealer.regionCode);
            }
            this.cityList = api.pca.getCityByProvince(this.dealer.provinceCode);
            this.districtList = this.cityList.filter(
              (i) => i.code == this.dealer.cityCode
            )[0]?.children;
            //更改是否接洽等合作状态的数据，更改博世主销机型数据
            this.onChange();

            this.getDisOption();
          }
        })
        .catch((err) => {
          console.log(err);
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDeleteDis() {
      this.loading = true;
      api.dealer
        .deleteDealer({
          id: this.dealerId,
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.message = {
              show: true,
              type: "success",
              text: "删除成功！",
            };
            this.$router.push({
              path: "/distributor/list",
            });
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "删除失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    onSaveDis() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;

      if (
        this.dealer.ovenSaleCapacity &&
        this.dealer.sowShowValue &&
        this.dealer.ovenSaleCapacity != 0
      ) {
        this.dealer.boschOvenSaleCapacity = Math.round(
          (this.dealer.sowShowValue / 100) * this.dealer.ovenSaleCapacity
        );
        this.dealer.sowValue = this.dealer.sowShowValue / 100;
      }
      if (
        this.dealer.ventilationSaleCapacity &&
        this.dealer.sowShowValueXF &&
        this.dealer.ventilationSaleCapacity != 0
      ) {
        this.dealer.boschVentilationSaleCapacity = Math.round(
          (this.dealer.sowShowValueXF / 100) *
            this.dealer.ventilationSaleCapacity
        );
        this.dealer.sowValueXF = this.dealer.sowShowValueXF / 100;
      }
      if (
        this.dealer.hotPumpSaleCapacity &&
        this.dealer.sowShowValueRB &&
        this.dealer.ovenSaleCapacity != 0
      ) {
        this.dealer.boschHotPumpSaleCapacity = Math.round(
          (this.dealer.sowShowValueRB / 100) * this.dealer.hotPumpSaleCapacity
        );
        this.dealer.sowValueRB = this.dealer.sowShowValueRB / 100;
      }
      const data = {
        ...this.dealer,
        actualCooperationDate: `${this.dealer.actualCooperationDate}-01`,
        majorBoschProductTypeIds:
          this.dealer.majorBoschProductTypeIds == null ||
          this.dealer.majorBoschProductTypeIds == "" ||
          this.dealer.majorBoschProductTypeIds == undefined
            ? null
            : this.dealer?.majorBoschProductTypeIds?.join(","),
        majorSaleChannelIds: this.dealer?.majorSaleChannelIds?.join(","),
      };
      delete data.developmentState;
      if (!data.parentDealerId) {
        data.parentDealer = null;
      }
      api.dealer
        .addDealer(data)
        .then((res) => {
          if (res.data.status == 0) {
            this.message = {
              show: true,
              type: "success",
              text: "保存成功！",
            };
            setTimeout(() => {
              this.$router.push({
                path: "/distributor/list",
              });
            }, 1000);
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "保存失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    async getDisOption() {
      // if (!regionCode) {
      //   regionCode = this.user.userRegionCode;
      // }
      api.dealer.getDealerList('/dealer/list').then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data?.length) {
          const list = data
            ?.filter(
              (i) =>
                (!i.parentDealerId || i.parentDealerId == -1) &&
                i.id != this.dealerId
            )
            .map((item) => {
              return {
                ...item,
                id: Number(item.id),
              };
            });
          list.unshift({
            id: null,
            name: "一级经销商",
          });
          this.dealers = list;
        }
      });
    },
  },
};
</script>

<style lang="sass">
#disDetail
  height: calc(var(--vh, 1vh) * 100 - 48px)
  width: 100%
  .v-snack__content
    padding: 0
  #detailForm
    width: 100%
    height: calc(100% - 40px)
    overflow: auto
</style>
